import Style from './index.module.less'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BlockDetailItem } from '@/api/blocks/interface'
import { getFormatTimeZone, isEmptyOrNil } from '@/utils'
import { formatValue, ugagToGag, ugagToGag2, ugeaToGea2, ugeaToGea3 } from '@/utils/number'
import { dealMoniker } from '@/views/BlockChain/util'
import { useGlobalStore } from '@/hoxStore/globalStore'
import LoadingCom from '@/components/LoadingCom'
const LatestBlockFour = ({
  style = {},
  blockDetail,
  loading = false,
}: {
  style?: React.CSSProperties
  blockDetail: BlockDetailItem
  loading: boolean
}) => {
  const { t } = useTranslation()
  const { curReponsive } = useGlobalStore()

  const [rewardGag, setRewardGag] = useState<{
    value: string
    sigin: string
  }>({
    value: '-',
    sigin: '',
  })
  const [rewardGea, setRewardGea] = useState<{
    value: string
    sigin: string
  }>({
    value: '-',
    sigin: '',
  })

  const getGag = () => {
    if (isEmptyOrNil(blockDetail.reward)) return
    const str = blockDetail.reward.split(',')
    str.forEach((item) => {
      if (item.includes('ugag')) {
        setRewardGag(ugagToGag(item))
      } else {
        setRewardGea(ugeaToGea2(item))
      }
    })
  }

  useEffect(() => {
    getGag()
  }, [blockDetail])

  const getItemRegionId = (item: any) => {
    if (isEmptyOrNil(item?.region_id)) return '-'
    if (item?.region_id?.toLocaleUpperCase() === 'GLOBAL_VILLAGE') return t('explorer_266')
    return item?.region_id?.toLocaleUpperCase()
  }

  return (
    <div
      style={{ ...style }}
      className={classNames({
        [Style.wrap]: true,
      })}
    >
      {loading && <LoadingCom></LoadingCom>}
      <div className={Style.item}>
        {/* 区块哈希 */}
        <span
          className={classNames({
            font_14: true,
            font_12: curReponsive?.size === 'mobile',
            [Style.item_title]: true,
          })}
        >
          {t('explorer_99')}:
        </span>
        <div
          className={classNames({
            [Style.textStyleOne]: true,
            font_14: true,
            font_12: curReponsive?.size === 'mobile',
            text_align_left: true,
          })}
        >
          {formatValue(blockDetail.hash)}
        </div>
      </div>
      <div className={Style.item}>
        {/* 当前时区 */}
        <span
          className={classNames({
            font_14: true,
            font_12: curReponsive?.size === 'mobile',
            [Style.item_title]: true,
          })}
        >
          {t('explorer_95')}:
        </span>
        <div className={classNames(Style.textStyleOne, 'font_14')}>
          {isEmptyOrNil(blockDetail.timestamp)
            ? '-'
            : getFormatTimeZone(blockDetail.timestamp).currentTime}
        </div>
      </div>
      <div className={Style.item}>
        {/* 时间 */}
        <span
          className={classNames({
            font_14: true,
            font_12: curReponsive?.size === 'mobile',
            [Style.item_title]: true,
          })}
        >
          UTC+0 {t('explorer_23')}:
        </span>
        <div className={classNames(Style.textStyleOne, 'font_14')}>
          {isEmptyOrNil(blockDetail.timestamp)
            ? '-'
            : getFormatTimeZone(blockDetail.timestamp).timeUtc0}
        </div>
      </div>

      <div className={Style.item}>
        {/* 交易数 */}
        <span
          className={classNames({
            font_14: true,
            font_12: curReponsive?.size === 'mobile',
            [Style.item_title]: true,
          })}
        >
          {t('explorer_101')}:
        </span>
        <div className={classNames(Style.textStyleOne, 'font_14')}>
          {formatValue(blockDetail.num_txs)}
        </div>
      </div>
      <div className={Style.item}>
        <span
          className={classNames({
            font_14: true,
            font_12: curReponsive?.size === 'mobile',
            [Style.item_title]: true,
          })}
        >
          GasFee:
        </span>
        <div className={classNames(Style.textStyleOne, 'font_14')}>
          <span> {ugeaToGea2(blockDetail?.gas_fee).value} </span>
          <span>{ugeaToGea2(blockDetail?.gas_fee).sigin}</span>
        </div>
      </div>
      <div className={Style.item}>
        {/* 提案节点 */}
        <span
          className={classNames({
            font_14: true,
            font_12: curReponsive?.size === 'mobile',
            [Style.item_title]: true,
          })}
        >
          {t('explorer_94')}:
        </span>
        <div
          className={classNames({
            [Style.textStyleTwo]: true,
            font_14: true,
          })}
        >
          <span>{dealMoniker(blockDetail?.validator_description?.moniker)}</span>
        </div>
      </div>
      <div
        className={classNames({
          [Style.item]: true,
          [Style.itemTwo]: true,
        })}
      >
        {/* 提案节点 */}
        <span
          className={classNames({
            font_14: true,
            font_12: curReponsive?.size === 'mobile',
            [Style.item_title]: true,
          })}
        >
          {t('explorer_91')}:
        </span>
        <div
          className={classNames({
            [Style.textStyleOne]: true,
            [Style.proposal_node]: true,
            font_14: true,
          })}
        >
          <div>
            <div className={Style.m_r_8}>
              {rewardGea.value} <span style={{ color: '#7C7D7D' }}>{rewardGea.sigin}</span>
            </div>
            <div className={Style.proposal_node_flex}>
              {blockDetail.reward_allocates?.slice(0, 2).map((item, index) => (
                <div key={item.region_id}>
                  <span style={{ color: '#7C7D7D' }}>{getItemRegionId(item)}</span>:{' '}
                  {ugeaToGea3(item.gea_coins.amount, item.gea_coins.denom).value}{' '}
                  <span style={{ color: '#7C7D7D' }}>
                    {ugeaToGea3(item.gea_coins.amount, item.gea_coins.denom).sigin}
                  </span>
                  {index !== blockDetail.reward_allocates?.slice(0, 2).length - 1 && (
                    <span className={Style.slash}>/</span>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className={Style.m_r_8}>
            <div className={Style.m_r_8}>
              {rewardGag.value} <span style={{ color: '#7C7D7D' }}>{rewardGag.sigin}</span>
            </div>
            <div className={Style.proposal_node_flex}>
              {blockDetail.reward_allocates?.slice(0, 2).map((item, index) => (
                <div key={item.region_id}>
                  <span style={{ color: '#7C7D7D' }}>{getItemRegionId(item)}</span>:{' '}
                  {ugagToGag2(item.gag_coins.amount, item.gag_coins.denom).value}{' '}
                  <span style={{ color: '#7C7D7D' }}>
                    {ugagToGag2(item.gea_coins.amount, item.gea_coins.denom).sigin}
                  </span>
                  {index !== blockDetail.reward_allocates?.slice(0, 2).length - 1 && (
                    <span className={Style.slash}>/</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LatestBlockFour
